<template>
  <div class="header">
    <div class="pagew header-box">
      <!-- logo区域 -->
      <div class="logo_content">
        <img src="@/assets/image/logo.png" alt="" />
      </div>
      <!-- 导航区域 -->
      <div class="nav-list">
        <router-link class="nav-btn" to="/homepage">首页</router-link>
        <router-link class="nav-btn" to="/match" >大赛介绍</router-link>
        <router-link class="nav-btn" to="/newsnote" >大赛通知</router-link>
        <router-link class="nav-btn" to="/newscity" >地市赛</router-link>
        <router-link class="nav-btn" to="/newstopic" >专题赛</router-link>
        <router-link class="nav-btn" to="/boc" >中国银行专栏</router-link>
        <router-link class="nav-btn" to="/matchinte" >“创客中国”信息技术应用专题赛</router-link>
        <router-link class="nav-btn" to="/newscontact" >各赛事联系方式</router-link>
        <router-link class="nav-btn" to="/newsreport">赛事新闻</router-link>
      </div>

      <div class="help-btn" v-show="false">
        <a
          href="javascript:void(0);"
          @mouseenter="onShowQrCode"
          @mouseleave="onHide"
          >参赛咨询</a
        >
        |
        <a
          href="http://8.134.120.63/ziliao.rar"
          target="_blank"
          download="创客广东大赛资料.zip"
          >下载服务</a
        >

        <div class="qr-img" v-show="showQr">
          <img src="../../assets/image/qr-code.jpg" />
        </div>
      </div>
      <!-- 按钮区域 -->
      <div class="btns_content" v-show="false">
        <el-button class="regiest" @click="goLogin"><span style="color: white">点击报名</span></el-button>
<!--        <a  href="http://i.gdsme.org/news/newsdetail?id=98&title=2023%E2%80%9C%E5%88%9B%E5%AE%A2%E5%B9%BF%E4%B8%9C%22%E8%B5%9B%E4%BA%8B%E6%8A%A5%E5%90%8D%E6%88%AA%E6%AD%A2%E6%97%A5%E6%9C%9F" icon="el-icon-view" style="color: #044fa6;font-weight: bold">查看报名截止时间</a>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: String,
      default: "/homepage",
    },
  },
  data() {
    return {
      // activeIndex: "/homepage",
      showQr: false,
    };
  },
  methods: {
    onShowQrCode() {
      this.showQr = true;
    },
    onHide() {
      this.showQr = false;
    },
    handleSelect(key, keyPath) {
      this.$router.push(key);
    },
    goLogin() {
      window.location.href = "http://admin.gdsme.org";
      // window.location.href = "http://localhost";
      // window.location.href = "http://" + this.$serverAddress;
    },
    goregister() {
      window.location.href = "http://admin.gdsme.org";
      // window.location.href = "http://localhost";
      // window.location.href = "http://" + this.$serverAddress;
    },
    toMainPage() {
      const id = 15;
      const title = '';
      this.$router.push({
        path: "/news/newsdetail",
        query: {
          id,
          title,
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.qr-img {
  position: absolute;
  right: 100px;
  top: 40px;
  width: 120px;
  left: -30px;
}
.qr-img::before {
  content: "";
  width: 0;
  height: 0;
  border-width: 10px;
  border-color: transparent transparent #fff;
  border-style: solid;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -18px;
}
.login {
  background-color: transparent;
  border: 1px solid #044fa6;
  width: 90px;
  height: 40px;
  color: #044fa6;
}
.regiest {
  width: 120px;
  height: 40px;
  background-color: #044fa6;
  color: #ffffff;
}
.el-menu {
  background-color: none;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.header {
  background-color: rgba($color: #fff, $alpha: 0.65);
  width: 100%;
  height: 94px;
  position: fixed;
  z-index: 500;
  top: 0;
  left: 0;
  box-shadow: 0 2px 10px 0 rgb(70 130 242 / 20%);

  .logo_content {
    width: 100px;
    margin-right: 30px;
    display: flex;
    justify-content: flex-end;
  }
}
.header-box {
  display: flex;
  height: 100%;
  justify-content: space-around;
  align-items: center;
}
.nav-list {
  font-size: 0;
}
.nav-btn {
  line-height: 94px;
  padding: 0 10px;
  display: inline-block;
  font-size: 14px;
  margin-right: 1px;
  min-width: 38px;
  font-weight: 700;
}
.help-btn {
  position: relative;
  a {
    width: 60px;
  }
}
</style>
<style lang="scss">
.nav-list .nav-btn:hover,
.nav-btn.router-link-active {
  color: #fff;
  background: #044fa6;
}
.el-menu-demo .nav-btn:hover {
  background: #044fa6;
}

.select-div ul li {
  cursor: pointer;
  list-style: none;
  line-height: 60px;
  a{
    padding: 8px 5px;
    font-size: 14px;
    font-weight: 700;
  }
}
.select-div ul li:hover {
  background: #044fa6;
  a {
    color: #fff;
  }
}
.select-div {
  background-color: rgba($color: #fff, $alpha: 0.65);
  position: absolute;
  top: 92px;
  left: 340px;
  display: none;
}
.setactive:hover{
  .select-div{
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue